import React from "react";
import ReactDOM from "react-dom/client";
import Gallery from "./Gallery";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Gallery />
  </React.StrictMode>,
);
